export const getLocalizedPlanPricing = (planDetails, region) => {
    const isIN = region === 'IN';
    return {
        starter: planDetails[isIN ? 'starter_IN' : 'starter'],
        team: planDetails[isIN ? 'team_IN' : 'team'],
    };
}